import React from 'react';
import { ChangeHandler, Control } from 'react-hook-form';
import { useLingui } from '@lingui/react/macro';

import { Box } from '@rover/kibble/core';
import SwitchField from '@rover/kibble/forms/fields/SwitchField';
import useTheme from '@rover/kibble/themes/useTheme';

type Props = {
  onChange: (arg0: boolean) => void;
  value: boolean;
  disabled?: boolean;
};

const SittersRatesToggle = ({ value, onChange, disabled }: Props): JSX.Element => {
  const { t } = useLingui();
  const { colors } = useTheme();

  const fieldProps = {
    name: 'showSittersRates',
    checked: value,
    onChange: ((e: { target: { checked: boolean } }) =>
      onChange(e.target.checked)) as ChangeHandler,
    onBlur: async () => {},
    ref: () => {},
  };

  return (
    <Box data-testid="sitters-rates-toggle" mt="4x">
      <SwitchField
        primaryLabel={t`See sitters' rates`}
        useBoldPrimaryLabel
        primaryLabelSize="100"
        disabled={disabled}
        onChange={onChange}
        fieldProps={fieldProps}
        name="showSittersRates"
        control={{} as Control<{ showSittersRates: boolean }>}
        required={false}
      />
      <Box mt="2x" borderBottom={`1px solid ${colors.border.primary.toString()}`} width="100%" />
    </Box>
  );
};

export default SittersRatesToggle;
